import { render, staticRenderFns } from "./GroupManagementTable.vue?vue&type=template&id=4e88b643"
import script from "./GroupManagementTable.vue?vue&type=script&lang=js"
export * from "./GroupManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports